import { render, staticRenderFns } from "./relatorioContratos.vue?vue&type=template&id=b98a5fd6"
import script from "./relatorioContratos.vue?vue&type=script&lang=js"
export * from "./relatorioContratos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports